import React from "react";
import { Tabs } from "antd";
import PhoneTemplate from "./phoneTemplate";
import Vehicle from "./vehicle";
import Driver from "./driver";
import PickupLocatioin from "./pickupLocation";
import Product from "./product";
import Distribution from "./distribution";

const items = [
	{
		key: "1",
		label: "短信模版",
		children: <PhoneTemplate />,
	},
	{
		key: "2",
		label: "车辆",
		children: <Vehicle />,
	},
	{
		key: "3",
		label: "司机",
		children: <Driver />,
	},
	{
		key: "4",
		label: "接送点",
		children: <PickupLocatioin />,
	},
	{
		key: "5",
		label: "产品",
		children: <Product />,
	},
	{
		key: "6",
		label: "渠道",
		children: <Distribution />,
	},
];

const SettingsPage = () => {
	const handleChange = (key) => {
		localStorage.setItem("settingsTabKey", key);
	};

	const selectedKey = localStorage.getItem("settingsTabKey") ?? 1;

	return (
		<Tabs
			defaultActiveKey={selectedKey}
			items={items}
			onChange={handleChange}
		/>
	);
};
export default SettingsPage;
